import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('BrandNavigation', BrandNavigation);

    /* @ngInject */
    function BrandNavigation() {
        BrandNavigation.prototype = {
            build: build,
            buildEmpty: buildEmpty,
        };

        function BrandNavigation(brandNavigationData) {
            if (!brandNavigationData) {
                this.buildEmpty();
            } else {
                this.build(brandNavigationData);
            }
        }

        return BrandNavigation;

        /////////////////////

        function buildEmpty() {
            this.fontColor = null;
            this.fontTitle = null;
            this.fontText = null;
            this.headerBGColor = null;
            this.headerTextColor = null;
            this.headerBorderColor = null;
            this.navBGColor = null;
            this.navLinkColor = null;
            this.navActiveLinkColor = null;
            this.navOpacityColor = null;
            this.buttonBGColor = null;
            this.btnPrimaryTextColor = null;
            this.primaryTextColor = null;
            this.primaryColor = null;
            this.secondaryColor = null;
            this.lightColor = null;
        }

        function build(brandNavigationData) {
            this.fontColor = brandNavigationData.fontColor || null;
            this.fontTitle = brandNavigationData.fontTitle || null;
            this.fontText = brandNavigationData.fontText || null;
            this.headerBGColor = brandNavigationData.headerBGColor || null;
            this.headerTextColor = brandNavigationData.headerTextColor || null;
            this.headerBorderColor = brandNavigationData.headerBorderColor || null;
            this.navBGColor = brandNavigationData.navBGColor || null;
            this.navLinkColor = brandNavigationData.navLinkColor || null;
            this.navActiveLinkColor = brandNavigationData.navActiveLinkColor || null;
            this.navOpacityColor = brandNavigationData.navOpacityColor || null;
            this.buttonBGColor = brandNavigationData.buttonBGColor || null;
            this.btnPrimaryTextColor = brandNavigationData.btnPrimaryTextColor || null;
            this.primaryTextColor = brandNavigationData.primaryTextColor || null;
            this.primaryColor = brandNavigationData.primaryColor || null;
            this.secondaryColor = brandNavigationData.secondaryColor || null;
            this.lightColor = brandNavigationData.lightColor || null;
        }
    }
})();
